import React from 'react';
import PaymentResult from './PaymentResult';

export default function AbortedPayment() {
  return <PaymentResult status="aborted" />;
}